import { createContext } from 'react';

import { defaultYAxis } from '../constants/defaults.js';
import { HistogramChartYAxisConfig } from '../types/histogram.js';

export const HistogramYAxisConfigContext =
  createContext<HistogramChartYAxisConfig>(defaultYAxis);

HistogramYAxisConfigContext['displayName'] = 'HistogramYAxisConfigContext';
